import { uploadFile } from "@/api";
import { useState } from "react";
import { MAX_FILE_SIZES } from "../helpers";

export const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const handleUploadFile = async (file: File) => {
    const fileSize = file?.size ?? 0;
    const fileExt = file?.name?.split?.(".")?.pop()?.toLowerCase() ?? "";

    const allowed = MAX_FILE_SIZES[fileExt];
    if (!allowed) {
      alert("Непідтримуваний тип файлу");
      return;
    }


    if (fileSize > allowed) {
      alert(`Файл повинен бути менше ${allowed / 1024 / 1024} mb`);
      return;
    }

    setIsLoading(true);
    try {
      return await uploadFile(file);
    } catch (error) {
      alert("Сталася помилка при завантаженні файлу, спробуйте ще раз");
      return;
    } finally {
      setIsLoading(false);
    }
  };

  return { uploadFile: handleUploadFile, isLoading };
};
